import React, { Component } from 'react';
import Button from '../../../components/button/Button';
import Toast from '../../../components/toast/Toast';
import { syncTime } from '../../../service/command';
import { formatDateTime } from '../../../js/utils';

export default class QuitShutdown extends Component {
  onConfirm() {
    const loading = Toast.loading('正在校准时间...');
    // 本机时间
   const nowTime = `"${formatDateTime(new Date())}"`;
    // const nowTime = `"2021-05-10 13:51:00"`
    syncTime(nowTime).then(() => {
      this.props.closePanel();
      Toast.success('校准成功');
    }).catch((error) => {
      Toast.fail(error);
    }).then(() => {
      loading.destroy();
    });
  }

  render() {
    return (
      <div>
        <div style={{ textAlign: 'center', margin: '10px' }}>是否同步地磁与本机时间</div>
        <div style={{ textAlign: 'center' }}>
          <Button type="primary" onClick={() => this.onConfirm()}>确认同步</Button>
        </div>
      </div>
    );
  }
}
